<template>
  <button
    class="text-plum-dark text-sm"
    type="button"
    @click.stop="openArticle"
  >
    <a
      :href="zendeskLink"
      class="text-plum-dark flex items-center"
      target="_blank"
    >
      <i class="fa-regular fa-question-circle" />
      <h2
        v-if="text"
        class="text-base font-semibold ml-2 hover:underline"
      >
        {{ text }}
      </h2>
    </a>
  </button>
</template>

<script>
export default {
  props: {
    articleId: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    zendeskLink() {
      return `https://help.openly.com/hc/en-us/articles/${this.articleId}`
    },
  },
  methods: {
    openArticle() {
      window.analytics.track('Zendesk Article Link Click', {
        articleId: this.articleId,
      })
    },
  },
}
</script>
